var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 2.90039C8.44173 2.90039 8.7999 3.25856 8.7999 3.70039V7.70039H12.7999C13.2417 7.70039 13.5999 8.05856 13.5999 8.50039C13.5999 8.94222 13.2417 9.30039 12.7999 9.30039H8.7999V13.3004C8.7999 13.7422 8.44173 14.1004 7.9999 14.1004C7.55807 14.1004 7.1999 13.7422 7.1999 13.3004V9.30039H3.1999C2.75807 9.30039 2.3999 8.94222 2.3999 8.50039C2.3999 8.05856 2.75807 7.70039 3.1999 7.70039H7.1999V3.70039C7.1999 3.25856 7.55807 2.90039 7.9999 2.90039Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPlusIcon);
export default __webpack_public_path__ + "static/media/grayPlusIcon.fe985310c1497658b00b450145002f96.svg";
export { ForwardRef as ReactComponent };